export const VideoPlaylist = {
  transclude: true,

  bindings: {
    autoplay: '<',
    continuous: '<',
    list: '<',
    loop: '<',
  },

  template: `
    <div class="video-playlist row">
      <div class="col-lg-8 mb-1">
        <video-player
          autoplay="$ctrl.autoplay"
          video-id="$ctrl.list[$ctrl.index].id"
          on-complete="$ctrl.setIndex($ctrl.index + 1)">
        </video-player>
        <div class="mt-4" ng-transclude></div>
      </div>
      <div class="col-lg-4">
        <div class="list-group">
          <a class="list-group-item list-group-item-action list-group-item--no-radius d-flex p-0 mb-1 border-0"
            href="#"
            ng-class="{
              'active': $ctrl.index === $index,
              'bg-gray-100': $ctrl.index !== $index
            }"
            ng-click="$ctrl.setIndex($index)"
            ng-repeat="item in $ctrl.list track by $index">
            <div class="list-group-item--image">
              <img ng-src="{{ item.thumbnailUrl.largeThumb | assetSrc }}">
            </div>
            <div class="list-group-item--content p-3">
              <div class="d-flex w-100 justify-content-between">
                <h6 ng-class="{
                  'mb-0': !item.description && !item.duration,
                  'mb-1': item.description || item.duration,
                  'text-dark': $ctrl.index !== $index,
                }">
                  {{ item.title }}
                </h6>
              </div>
              <p
                ng-class="{ 'mb-1': item.duration }"
                ng-if="item.description">
                {{ item.description }}
              </p>
              <small ng-if="item.duration">
                {{ item.duration }}
              </small>
            </div>
          </a>
        </div>
      </div>
    </div>`,

  controller($timeout) {
    'ngInject';

    return {
      $onInit() {
        this.index = 0;
      },

      $onDestroy() {
        this.player && this.player.off('complete');
      },

      onLoad(player) {
        this.player = player;
        this.player.on('ended', () => this.setIndex(this.index + 1));
      },

      setIndex(index) {
        $timeout(() => {
          if (!this.list[index]) {
            this.autoplay = this.loop && this.continuous;
            this.index = 0;
          } else {
            this.autoplay = this.autoplay || this.continuous;
            this.index = index;
          }
        });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Video/VideoPlaylist.js